import { apiWrapper } from "@/services/api";

export const putMamoruQR = async (frame_id, route, item_name) => {
  try {
    await apiWrapper(
      "PUT",
      `frames/${frame_id}/mamoru_qr?qr_string=${route.query.mamoru_auth}&product_name=odakyu&item_name=${item_name}&target_location_id=${route.query.location_id}`
    );
  } catch (err) {
    console.log('ERROR"" putMamoruQR()');
    throw err;
  }
};
